import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageState } from 'models/PageState';
import { delay } from 'utils';
import { getMainMenuOpen, getMainMenuItems } from 'components/MainMenu/selectors';
import { closeMainMenu, isPageLoading, openMainMenu } from 'components/MainMenu/actions';
import { useMenuToggle } from 'components/MainMenu/useMenuToggle';
import { SectionLink } from './section';
import styles from './styles.scss';

const DesktopMenu = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state: PageState) => isPageLoading(state.currentPage));

  const isOpen = useSelector(getMainMenuOpen);
  const sections = useSelector(getMainMenuItems);

  const delayRef = useRef(delay());
  useEffect(() => delayRef.current.cleanup, []);
  const toggle = useCallback(
    (open: boolean) =>
      delayRef.current.setDelay(() =>
        open ? dispatch(openMainMenu()) : dispatch(closeMainMenu())
      ),
    [dispatch]
  );
  const onMouseOver = () => toggle(true);
  const onMouseOut = () => toggle(false);
  const [openId, open, close] = useMenuToggle<string>(isOpen, isLoading);

  return (
    <nav
      className={styles.menu}
      onMouseOut={onMouseOut}
      onMouseOver={onMouseOver}
      onTouchStart={onMouseOver}
    >
      {sections.map(section => (
        <SectionLink
          key={section.id}
          section={section}
          openMenu={open(section.id)}
          closeMenu={close}
          openId={openId}
          menuOpen={isOpen}
          isLoading={isLoading}
          hideDropdown={section.hideDropdown}
        />
      ))}
    </nav>
  );
};

export default DesktopMenu;
